import React from 'react'
import Navbar from './Navbar';
import BannerScroller from './BannerScroller';
import RealEstateHero from './RealEstateHero';
import PropertySection from './Properties';
import PropertyRentels from './PropertyRentels';
import PropertyManagementHero from './ProjectManagementHero';
import FeaturedProjects from './Featureprojects';
import Footer from './Footer';



function HomeIndex() {
  return (
    <div>
      <Navbar />
      <RealEstateHero />
      <PropertySection />
      {/* <PropertyManagementHero /> */}
      {/* <BannerScroller /> */}
      <PropertyRentels />
      <FeaturedProjects />
      <Footer />
    </div>
  )
}

export default HomeIndex
